import axios from 'axios';
import { supabase } from '../config/supabase.config';
import { API_URL } from '../config/supabase.config';
import { ReportData, DateRange } from '../types/reports.types';

const getAuthHeader = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  return {
    headers: {
      Authorization: `Bearer ${session?.access_token}`,
      'Content-Type': 'application/json',
    },
  };
};

export const reportsService = {
  // Use backend API for report data - backend handles org_role filtering
  async getReportData(dateRange?: DateRange): Promise<ReportData> {
    try {
      console.log('Fetching report data from:', `${API_URL}/reports`);
      const config = await getAuthHeader();
      console.log('Auth config:', config);
      const response = await axios.get(`${API_URL}/reports`, {
        ...config,
        params: dateRange,
      });
      console.log('Report data response:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('Failed to fetch report data from backend:', error);
      console.error('Error details:', error.response?.data || error.message);
      console.error('Status code:', error.response?.status);
      throw error;
    }
  },

  // Use backend API for CSV export - backend handles org_role filtering
  async exportToCSV(dateRange?: DateRange): Promise<Blob> {
    try {
      const config = await getAuthHeader();
      const response = await axios.get(`${API_URL}/reports/export`, {
        ...config,
        params: { ...dateRange, format: 'csv' },
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      console.error('Failed to export report:', error);
      throw error;
    }
  },
};